import { render, staticRenderFns } from "./AppointmentDetails.vue?vue&type=template&id=1613f7fc&scoped=true&"
import script from "./AppointmentDetails.vue?vue&type=script&lang=ts&"
export * from "./AppointmentDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentDetails.vue?vue&type=style&index=0&id=1613f7fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1613f7fc",
  null
  
)

export default component.exports